import * as Yup from 'yup';
import { parse as parseDomain } from 'tldts';
import isEmail from 'validator/lib/isEmail';

const matcherEmailValidation = Yup.string()
  .trim()
  .transform((value) => (value === '' ? undefined : value))
  .max(80, 'Please use 80 characters or less.')
  .test('is-email', 'Please enter a valid email.', (value) => {
    if (!value) {
      return true;
    }
    if (!isEmail(value)) {
      return false;
    }
    const domain = value.split('@').pop()!;
    const { isIcann } = parseDomain(domain);
    return isIcann === true;
  })
  .nullable()
  .notRequired();

const matcherEmailSchema = Yup.object({
  email: matcherEmailValidation
});

export { matcherEmailSchema };
